import React, {useState} from "react";
import {Grid2} from "@mui/material";
import Typography from "@mui/material/Typography";
import {UserProfileDTO} from "../ProfilePersonalDetails";
import IconButton from "@mui/material/IconButton";
import {EditOutlined} from "@mui/icons-material";
import UpdateMailModal from "./profileEditableSectionUpdateMailModal/UpdateMailModal";
import UpdatePasswordModal from "./profileEditableSectionUpdatePasswordModal/UpdatePasswordModal";

interface ProfileAccountDetailsProps {
    profile: UserProfileDTO,
}

const ProfileAccountDetails = ({profile}: ProfileAccountDetailsProps) => {

    const [openUpdateMailModal, setOpenUpdateMailModal] = useState(false);
    const [openUpdatePasswordModal, setOpenUpdatePasswordModal] = useState(false);

    return (
        <>
            <Grid2 container size={12} mr={"5px"} ml={"5px"} sx={{borderBottom: '1px solid black'}}>
                <Grid2 container size={12} sx={{minHeight: '50px', borderTop: '1px solid black'}}>
                    <Grid2 container size={9}>
                        <Grid2
                            size={{xs: 12, sm: 4}}
                            sx={{
                                alignContent: 'center',
                            }}
                        >
                            <Typography
                                textAlign={"left"}
                                variant={"firstVariant"}
                                fontSize={{xs: '16px', sm: '18px'}}
                            >
                                Email
                            </Typography>
                        </Grid2>
                        <Grid2 size={{xs: 12, sm: 8}} sx={{alignContent: 'center'}}>
                            <Typography
                                textAlign={"left"}
                                variant={"firstVariant"}
                                fontSize={{xs: '14px', sm: '16px'}}
                            >
                                {profile.email}
                            </Typography>
                        </Grid2>
                    </Grid2>
                    <Grid2 size={3} sx={{
                        alignContent: 'center',
                        textAlign: 'left'
                    }}>
                        <IconButton
                            aria-label="Edit"
                            variant="thirdVariant"
                            onClick={(e) => setOpenUpdateMailModal(true)}
                        >
                            <EditOutlined
                                sx={{
                                    fontSize: {xs: '22px', sm: '25px'},
                                }}
                            />

                        </IconButton>
                    </Grid2>
                </Grid2>
                <Grid2 container size={12} sx={{minHeight: '50px', borderTop: '1px solid black'}}>
                    <Grid2 container size={9}>
                        <Grid2
                            size={{xs: 12, sm: 4}}
                            sx={{
                                alignContent: 'center',
                            }}
                        >
                            <Typography
                                textAlign={"left"}
                                variant={"firstVariant"}
                                fontSize={{xs: '16px', sm: '18px'}}
                            >
                                Mot de passe
                            </Typography>
                        </Grid2>
                        <Grid2 size={{xs: 12, sm: 8}} sx={{alignContent: 'center'}}>
                            <Typography
                                textAlign={"left"}
                                variant={"firstVariant"}
                                fontSize={{xs: '14px', sm: '16px'}}
                            >
                                ************
                            </Typography>
                        </Grid2>
                    </Grid2>
                    <Grid2 size={3} sx={{
                        alignContent: 'center',
                        textAlign: 'left'
                    }}>
                        <IconButton
                            aria-label="Edit"
                            variant="thirdVariant"
                            onClick={(e) => setOpenUpdatePasswordModal(true)}
                        >
                            <EditOutlined
                                sx={{
                                    fontSize: {xs: '22px', sm: '25px'},
                                }}
                            />

                        </IconButton>
                    </Grid2>
                </Grid2>
            </Grid2>
            <UpdateMailModal open={openUpdateMailModal} setOpen={setOpenUpdateMailModal}/>
            <UpdatePasswordModal open={openUpdatePasswordModal} setOpen={setOpenUpdatePasswordModal} email={profile.email}/>
        </>
    );
}

export default ProfileAccountDetails